export enum PRONOUNS {
  THEY_THEM = "they/them",
  SHE_HER = "she/her",
  HE_HIM = "he/him",
  OTHER = "other",
}
